// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1fbb74d4","455":"3238c0c9","977":"89ace697"}[chunkId] + ".chunk.js";
};